<template>
    <div class="py-3 m-0 wallpaper-secretario">
        <div class="my-0 container" v-scroll-reveal>
            <msj-secretario :verDato="verDato"></msj-secretario>
        </div>
    </div>
</template>
<script>
import msjSecretario from './../mensaje_secretario.vue'

export default({
    components:{
        msjSecretario
    },
    data: function() {
        return{
            verDato: true
        }
    },
})
</script>
<style scoped>

</style>
